import {useEffect} from 'react'
import styles from './housekeeping.module.css'
import { signOutOfFirebase} from '../firebase/firebase'
import { CheckInOutFormList } from './CheckInOutForm';

function Housekeeping({ setShowNavBar }) {

    useEffect(() => setShowNavBar(true));

    return (
        <div style={{padding: '1rem'}}>
            <h1 style={{marginTop: '5rem'}}>Housekeeping</h1>
            <CheckInOutFormList/>
        </div>
    )
}

export default Housekeeping